import React from 'react';
import {
  Button, SimpleForm, DateInput, AutocompleteArrayInput, SelectArrayInput, SelectInput, ReferenceArrayInput, Toolbar,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, SaveButton, required, FormDataConsumer, BooleanInput
} from 'react-admin';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import DataTable from 'react-data-table-component';
import { fetchUtils, usePermissions } from 'react-admin';
import { ExpandMore } from '@material-ui/icons';
import {Accordion, AccordionSummary, AccordionDetails, Box, Card} from "@material-ui/core";
import FilterCardTitle from '../common/filters/FilterCardTitle';
import { AlertComponent } from '../components/alerts.js';
import { NoBidChartComponent } from '../components/chart.js';
import { DisclaimerComponent } from '../components/disclaimer.js';
import { LegendComponent } from '../components/legend.js';
import DeleteWithConfirmation from '../components/DeleteWithConfirmation';
import { EmptyList } from '../components/empty';
const moment = require('moment-timezone');

const choicesAdType = require('../components/adtypes.json');
const choicesSizes = require('../components/sizes.json');
const choicesDevices = require('../components/devices.json');
const countryChoices = require('../components/countries.json');
const browserChoices = require('../components/browsers.json');
const utils = require('../components/utils');
const dataSupport = require('../components/data_support.js');
const fetch = fetchUtils.fetchJson;


const BASE_URL = window.nobid_endpoint+'/carbon/pubreports_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  let keys = Object.keys(array[0]);
  keys = keys.filter(key => (key!=='code' && key!=='adx_ad_requests' && key!=='id'));

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (key==='code' || key==='adx_ad_requests' || key==='id') return;
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function downloadCSV(array) {
  array.forEach((row, i) => {
    delete array[i].id
    delete array[i].code
  })
  dataSupport.exportData(array)
}

const prebidBidders = require('../prebidBidderModules.json');
const otherBidders = require('../carbonOtherBidders.json');
function prebidAndOtherBidders () {
  let ret = [{id: '', name: '--- PREBID ---', disabled: true},...prebidBidders];
  ret.push({id: '', name: '--- OTHER ---', disabled: true});
  ret = ret.concat(otherBidders);
  return ret;
};
const selectableBidders = prebidAndOtherBidders();

// moment.tz.names().map(tz => {return {id: tz, name: tz}});
const choicesTimezone = ['US/Eastern', 'UTC', 'US/Mountain', 'US/Pacific', 'US/Central', 'Europe/London', 'Europe/Paris', 'Europe/Helsinki'].map(x => {return {id: x, name: x}} );
const choicesInterval = [
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' },
  { id: 'year', name: 'Yearly' }
];
const choicesShowAdmin = [
  { id: '', name: '--- DIMENSIONS ---', disabled: true },
  { id: 'date', name: 'Date' },
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'tldomain', name: 'Domain/App' },
  { id: 'bidder_name', name: 'Bidder', roles: ['admin', 'publisher'] },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'browser', name: 'Browser' },
  { id: 'adsize', name: 'Ad Size' },
  { id: 'ad_type', name: 'Ad Type' },
  { id: '', name: '--- METRICS ---', disabled: true },
  { id: 'ad_requests', name: '#Ad Requests', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'ad_auctions', name: '#Auctions', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'bid_requests', name: '#Bid Requests', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'bid_responses', name: '#Bid Responses', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'opt_requests', name: '#Optimized Requests', metric: 1, roles: ['admin', ] },
  { id: 'bid_prices', name: '$Bid Prices', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'avg_bid_price', name: '$Avg Bid Price', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'fill_rate', name: '%Fill Rate', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'response_rate', name: '%Bid Response Rate', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'win_rate', name: '%Win Rate', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'bid_requests_rate', name: '%Bid Request Rate', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'bid_requests_impressions_ratio', name: '#Bid Requests Per Impression', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'bid_requests_ad_requests_ratio', name: '#Bid Requests Per Ad Request', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'opt_requests_rate', name: '%Optimized Requests Rate', metric: 1, roles: ['admin'] },
  { id: 'rpm_bid_requests', name: '$RPM Bid Requests', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'rpm_ad_requests', name: '$RPM Ad Requests', metric: 1, roles: ['admin', 'publisher'] },
  { id: 'tech_cost', name: '$Tech Cost', metric: 1, roles: ['admin'] }
]
const choicesShow = (permissions) => {
  if (!permissions) return [];
  return choicesShowAdmin.filter(x => { if (!x.roles || x.roles.includes(permissions.role)) return x });
}
function nameBySelector (selector) {
  return (choicesShowAdmin.find(x => x.id === selector)).name;
}
const BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true, cell: row => row.date, definition: 'Date dimension.' },
  { name: 'Publisher', selector: 'publisher_name', sortable: true, definition: 'Publisher dimension.' },
  { name: 'Site', selector: 'site_name', sortable: true, definition: 'Site Name dimension.' },
  { name: 'Site ID', selector: 'site_id', sortable: true, definition: 'Site ID dimension. Included in the Optimizer.' },
  { name: 'Domain/App', selector: 'tldomain', sortable: true, definition: 'Domain name or App name dimension.' },
  { name: 'Bidder', selector: 'bidder_name', sortable: true, definition: 'Bidder dimension. Included in the Optimizer.' },
  { name: 'Country', selector: 'country', sortable: true, definition: 'Country dimension. Included in the Optimizer.' },
  { name: 'Device', selector: 'device', sortable: true, definition: 'Device dimension. Included in the Optimizer.' },
  { name: 'Browser', selector: 'browser', sortable: true, definition: 'Browser dimension. Included in the Optimizer.' },
  { name: 'Ad Type', selector: 'ad_type', sortable: true, definition: 'Ad Type dimension. Included in the Optimizer.' },
  { name: 'Ad Size', selector: 'adsize', sortable: true, definition: 'Ad Size dimension.' },
  { name: '#Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span>, definition: 'Impressions served.' },
  { name: nameBySelector('ad_requests'), selector: 'ad_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.ad_requests) }</span>, definition: 'Incoming Ad Requests, equivalent to Ad Units.' },
  { name: nameBySelector('ad_auctions'), selector: 'ad_auctions', sortable: true, cell: row => <span>{ utils.formatLong(row.ad_auctions) }</span>, definition: 'Incoming Auctions.' },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span>, definition: 'Revenue generated by the impression in the currency defined in the Prebid wrapper.' },
  { name: '$Avg CPM', selector: 'avg_cpm', sortable: true, cell: row => <span>{Number(Number.parseFloat(row.avg_cpm).toFixed(2))}</span>, definition: 'The Average CPM is defined as 1,000 * Revenue / Impressions in US Dollars ($).' },
  { name: '#Bid Requests', selector: 'bid_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_requests) }</span>, definition: 'The Bid Requests sent from the Prebid wrapper to the Demand sources defined in the Prebid wrapper.' },
  { name: '#Bid Responses', selector: 'bid_responses', sortable: true, cell: row => <span>{ utils.formatLong(row.bid_responses) }</span>, definition: 'The Bid Responses received by the Prebid wrapper from the Demand sources.' },
  { name: nameBySelector('opt_requests'), selector: 'opt_requests', sortable: true, cell: row => <span>{ utils.formatLong(row.opt_requests) }</span>, definition: 'Optimized or Blocked Bid Requests.' },
  { name: nameBySelector('fill_rate'), selector: 'fill_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.fill_rate, '%') }</span>, definition: 'Defined as 100 * Impressions / Ad Requests.' },
  { name: '$Bid Prices', selector: 'bid_prices', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_prices) }</span>, definition: 'The total bid prices received by the Prebid wrapper from the Demand sources.' },
  { name: '$Avg Bid Price', selector: 'avg_bid_price', sortable: true, cell: row => <span>{ utils.formatDouble(row.avg_bid_price) }</span>, definition: 'The Average bid price defined as 1,000 * Total Bid Prices / Bid Responses.' },
  { name: '%Bid Response Rate', selector: 'response_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.response_rate, '%') }</span>, definition: 'The Bid Response Rate is defined as 100 * Bid Responses / Bid Requests.' },
  { name: '%Bid Requests Rate', selector: 'bid_requests_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_requests_rate, '%') }</span>, definition: 'The Bid Request Rate is defined as 100 * Impressions / Bid Requests.' },
  { name: '#Bid Requests Per Impression', selector: 'bid_requests_impressions_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_requests_impressions_ratio, ' ') }</span>, definition: 'Number of Bid Requests Per Impression. Defined as Bid Requests / Impressions.' },
  { name: '#Bid Requests Per Ad Request', selector: 'bid_requests_ad_requests_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.bid_requests_ad_requests_ratio, ' ') }</span>, definition: 'Number of Bid Requests Per Ad Requests. Defined as Bid Requests / Ad Requests.' },
  { name: '%Optimized Requests Rate', selector: 'opt_requests_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.opt_requests_rate, '%') }</span>, definition: 'Optimized requests is defined as the percentage of Optimized or Blocked Bid Requests Per total Bid Requests. Defined as Optimized Requests / (Optimized Requests + Bid Requests).' },
  { name: '%Win Rate', selector: 'win_rate', sortable: true, cell: row => <span>{ utils.formatDouble(row.win_rate, '%') }</span>, definition: 'The Win Rate is defined as 100 * Impressions / Bid Reponses.' },
  { name: '$RPM Bid Requests', selector: 'rpm_bid_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.rpm_bid_requests) }</span>, definition: 'The Revenue Per Million Bid Requests is defined as 1,000,000 * Revenue / Bid Requests.' },
  { name: '$RPM Ad Requests', selector: 'rpm_ad_requests', sortable: true, cell: row => <span>{ utils.formatDouble(row.rpm_ad_requests) }</span>, definition: 'The Revenue Per Million Ad Requests is defined as 1,000,000 * Revenue / Ad Requests.' },
  { name: '$Tech Cost', selector: 'tech_cost', sortable: true, cell: row => <span>{ utils.formatDouble(row.tech_cost) }</span>, definition: 'Daily Technology Cost is collected through the AWS Cost API is US Dollars (USD).' },
  // { name: nameBySelector('net_efficient_ratio'), selector: 'net_efficient_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.net_efficient_ratio, ' ') }</span>, definition: `The "${nameBySelector('net_efficient_ratio')}" is defined the total traffic (Ad Requets + Bid Requets) per Impression.` },
  // { name: nameBySelector('energy_efficient_ratio'), selector: 'energy_efficient_ratio', sortable: true, cell: row => <span>{ utils.formatDouble(row.energy_efficient_ratio, ' ') }</span>, definition: `The "${nameBySelector('energy_efficient_ratio')}" is an estimate of the CO2 emmissions generated based on network traffic, impressions served, device type, demand type,  impression type...` },
];

const defaultColumnSelectors = ['impressions', 'revenue', 'avg_cpm'];

const defaultChartMetrics = [
  { id: 'impressions', name: '#Impressions' },
  { id: 'revenue', name: '$Revenue' },
  { id: 'avg_cpm', name: '$Avg CPM'}
];
let chartMetricsChoices = (permissions, showColumns = []) => {
  if (!permissions) return defaultChartMetrics;
  return defaultChartMetrics.concat(choicesShowAdmin.filter(x => { if (x.metric && (!x.roles || x.roles.includes(permissions.role))) return x }));
};
const chartFormatChoices = [
	{id:'line', name:'Lines'},
	{id:'spline', name:'Smoothed'},
	{id:'column', name:'Bars'},
	{id:'area', name:'Area'},
];

const dateRangeChoices = [
  { id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
  { id: 5, name: 'Last 5 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
  { id: 15, name: 'Last 15 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
  { id: 'ytd', name: 'Year to Date' },
  { id: 'yty', name: 'Year to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];

let columns = [];

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    super(props);
    this.parent = props.parent;
  }

  updateChart = function(options) {
	  if (!this) return;
	  this.parent.refs.nobidChart.refreshChart(this.parent.state.data, chartMetricsChoices(this.parent.props.permissions, this.parent.state.columns), chartFormatChoices, options);
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date) r.date = r.date.indexOf('T') > 0 ? r.date.substring(0, r.date.indexOf('T')) : r.date;
      }

      const showList = formData.show || [];
      const columnSelectors = defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`, `${x}_group`]));

      that.parent.setState({
        data: json,
        saved_data:json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false});
      that.updateChart({metric: formData.metric, format: formData.format});
    }

    function formDataFields(formData, fields) {
      const buf = [];
      for(let i in fields) {
        let field = fields[i];
        if (formData[field] && Array.isArray(formData[field]) && formData[field].length>0) {
          formData[field].map(x => buf.push(`${field}=${x}`));
        } else if (formData[field]) {
          buf.push(`${field}=${formData[field]}`);
        }
      }
      return buf.length>0 ? `&${buf.join('&')}` : '';
    }

    formData.show = formData.show || [];
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });
    defaultColumnSelectors.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}` +
      `${formDataFields(
          formData,
          ['interval', 'date_range', 'start_date', 'end_date', 'publisher_id', 'site_id', 'bidder_name',
          'ad_type', 'device', 'adsize', 'country', 'timezone', 'browser',
          'publisher_id_exclude', 'site_id_exclude', 'bidder_name_exclude']
      )}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading}/>
      </Toolbar>
    )
  }
}

const PubReportTitle = ({ record }) => {
  return <span>Analytics Report {record ? `"${record.name}"` : ''}</span>;
};

const PubReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);
export const CarbonPublisherEarningReportList = ({ permissions, ...props }) => (
  <List {...props} empty={<EmptyList name="Analytics Report" />} title="Analytics Reports" perPage={25} bulkActionButtons={false} filters={<PubReportFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

const hasActiveFilters = (record) => {
  const filters = ['publisher_id', 'site_id', 'bidder_name', 'country', 'adsize', 'ad_type', 'device', 'browser', 'tldomain'];
  return record && filters.some( f => record[f] && record[f].length > 0)
}

class PubReportComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  updateChart = function(options) {
	  this.refs.nobidChart.refreshChart(this.state.data, chartMetricsChoices(this.props.permissions, this.state.columns), chartFormatChoices, options);
  }

  handleChartMetricChanged = (value) => {
	  this.updateChart({metric: value.target.value});
  }

  handleChartFormatChanged = (value) => {
	  this.updateChart({format: value.target.value});
  }
  
  render() {
    const { loading, data, dateRange } = this.state;
    const { permissions, formType, record } = this.props;

    return (
      <div>
        <AlertComponent />
        <Card>
          <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: '#424242', borderRadius: '5px' }} {...this.props}>
            <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
              <FormDataConsumer>
                {({ formData }) => setFormData(formData) }
              </FormDataConsumer>
              <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' 
                disabled={loading}/>
              <div>
                <SelectInput label="Date Range" source="date_range"
                  onChange={value => this.setState({ dateRange: value.target.value })}
                  choices={dateRangeChoices}
                  defaultValue="mtd"
                  disabled={loading} />
                <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                  </div>
                  <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                  </div>
                </div>
              </div>
              <div>
              <SelectInput label="Timezone" source="timezone" 
              choices={choicesTimezone} 
              defaultValue='US/Eastern' 
              disabled={loading}/>
              </div>
            </div>

            <Accordion defaultExpanded={true} style={{ marginBottom: '20px', backgroundColor: '#3e3e3e'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Dimensions / Metrics" values={true} />
              </AccordionSummary>
              <AccordionDetails>
              <div style={{alignSelf: 'flex-start', width: '100%'}}>
                <SelectArrayInput label="Show"
                  size="small"
                  source="show" 
                  choices={choicesShow(permissions)}
                  defaultValue={['date']}
                  style={{alignSelf: 'flex-start', width: '100%'}}
                  disabled={loading} />
              </div>
              </AccordionDetails>
            </Accordion>
              
            <Accordion defaultExpanded={formType==="create"} style={{ marginBottom: '20px', backgroundColor: '#3e3e3e'}} fullWidth>
              <AccordionSummary expandIcon={<ExpandMore />}>
                <FilterCardTitle title="Filters" values={hasActiveFilters(record)} />
              </AccordionSummary>
              <AccordionDetails>
                <Box style={{ width: '100%' }}>
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
                    <div style={{flex: 1}}>
                      <ReferenceArrayInput 
                        source="publisher_id" 
                        label="Publisher" 
                        reference="publishers"
                        basePath="publishers"
                        perPage={15} 
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        disabled={loading}>
                        <AutocompleteArrayInput disabled={loading}
                          label="Publishers"
                          optionText="name"
                          optionValue="code"
                          fullWidth/>
                      </ReferenceArrayInput>
                      <BooleanInput source="publisher_id_exclude" label="Exclude Publishers" disabled={loading} style={{marginLeft: '10px', width: '50%'}}/>
                    </div>

                    {permissions &&
                      <div style={{flex: 1}}>
                        <ReferenceArrayInput 
                          source="site_id" 
                          label="Site" 
                          reference="sites"
                          basePath='sites'
                          perPage={15} 
                          sort={{ field: 'name', order: 'ASC' }}
                          filterToQuery={searchText => utils.siteFormFilter(searchText, formData)}
                          allowEmpty
                          disabled={loading}>
                          <AutocompleteArrayInput disabled={loading} label="Sites" 
                            optionText={ x => utils.formatSiteName(x) }
                            optionValue="code"
                            fullWidth/>
                        </ReferenceArrayInput>
                        <BooleanInput source="site_id_exclude" label="Exclude Sites" disabled={loading} style={{marginLeft: '10px', width: '50%'}}/>
                      </div>
                    }
                  
                    <div style={{flex: 1}}>
                      <AutocompleteArrayInput label="Bidders" 
                      source="bidder_name" 
                      choices={selectableBidders}
                      disabled={loading}
                      fullWidth />
                      <BooleanInput source="bidder_name_exclude" label="Exclude Bidders" disabled={loading} style={{marginLeft: '10px', width: '50%'}}/>
                    </div>
                  </div>
              
                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Devices" 
                        source="device" 
                        choices={choicesDevices} 
                        disabled={loading}
                        fullWidth />
                    </div>

                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Ad Sizes" 
                        source="adsize" 
                        choices={choicesSizes} 
                        disabled={loading}
                        fullWidth />
                    </div>
                    
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Ad Type" 
                        source="ad_type" 
                        choices={choicesAdType}
                        disabled={loading}
                        fullWidth />
                    </div>
                  </div>

                  <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Countries"
                        source="country"
                        choices={countryChoices}
                        disabled={loading}
                        fullWidth/>
                    </div>
                    <div style={{flex: 1}}>
                      <SelectArrayInput label="Browsers"
                        source="browser"
                        choices={browserChoices}
                        disabled={loading}
                        fullWidth/>
                    </div>
                  </div>
                </Box>
              </AccordionDetails>
            </Accordion>
            <div style={{ width: '100%', overflow: 'hidden'}} >
              <div style={{ float:'right' }}>
                <SelectInput label="Chart Format" 
                  source='format' 
                  choices={chartFormatChoices}
                  defaultValue={'line'}
                  onChange={this.handleChartFormatChanged} 
                  disabled={loading}
                  style={{ paddingRight: '5px' }}
                />
                <SelectInput label="Show in Chart" 
                  source='metric' 
                  choices={chartMetricsChoices(permissions, this.state.columns)}
                  defaultValue={'revenue'}
                  onChange={this.handleChartMetricChanged} 
                  disabled={loading}
                />
              </div>
            </div>
          </SimpleForm>
        </Card>
        <div style={{ height: '15px', backgroundColor: '#303030'}} />
        <Card>
          <NoBidChartComponent ref="nobidChart" data={data}/>
        </Card>
        <div style={{ height: '15px', backgroundColor: '#303030'}} />
        <Card>
          <DataTable
            title="Analytics Report"
            theme="dark"
            columns={this.state.columns}
            data={data}
            progressPending={loading}
            pagination
            fixedHeader
            paginationPerPage={30}
            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
            dense
            highlightOnHover
            subHeader={!loading}
            subHeaderComponent={
              (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <input type="text" id='search_box' label="Search" 
                  variant="outlined" 
                  style={{ margin: '5px' }} 
                  onChange={(target) => dataSupport.filterData(this)}/>
                  <CloudDownload 
                  label="Export"
                  style={{ margin: '5px' }} 
                  color="action" 
                  onClick={() => downloadCSV(this.state.data)}
                  />
                </div>
              )
            }
          />
          
          <DisclaimerComponent />

          <LegendComponent columns={BASE_COLUMNS} choices={choicesShow(permissions)}/>

        </Card>
      </div>
    )
  }
};

export const CarbonPublisherEarningReportEdit = (props) => (
  <Edit title={<PubReportTitle />}  mutationMode="pessimistic" {...props}>
    <PubReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const CarbonPublisherEarningReportCreate = (props) => (
  <Create title="Create Analytics Report" mutationMode="pessimistic" {...props}>
    <PubReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
